import myAPI from './resources'
import config from '../config'


export default {
  getAll: async function (usa_state) {
    var documents = await myAPI.get(config.carbuyservice + '/statelaw/StateDocument/'+usa_state);
    var rules = await myAPI.get(config.carbuyservice + '/statelaw/StateRegulation/'+usa_state);
    var proofId = await myAPI.get(config.carbuyservice + '/statelaw/StateProofOfIdentification/'+usa_state);
    var stateOwnerRules = await myAPI.get(config.carbuyservice + '/statelaw/StateProofOfOwnership/'+usa_state);
    if(stateOwnerRules.data != {}) {
      var StateProofOfOwnership = stateOwnerRules.data[0].stateProofOfOwnershipID;
      var proofOwner = await myAPI.get(config.carbuyservice + '/statelaw/ProofOfOwnership/'+StateProofOfOwnership);
    }
    var proofOwnerTypes = await myAPI.get(config.carbuyservice + '/statelaw/ProofOfOwnershipType/');
    var proofIdTypes = await myAPI.get(config.carbuyservice + '/statelaw/ProofOfIdentificationType/');

    return {documents: documents.data, rules: rules.data, proofId: proofId.data, proofOwnerTypes: proofOwnerTypes.data, proofIdTypes: proofIdTypes.data, ownershipRules: stateOwnerRules.data, proofOwnershipRules: proofOwner.data};
   },
  save: function (statelaw) {
    if(statelaw.is_new) {
    return myAPI.post(config.api_root + config.api_root_path_admin + '/stateLaws', statelaw)
      .then(function (response) {
        return response
      })
    }
    else {
      return myAPI.put(config.api_root + config.api_root_path_admin + '/stateLaws', statelaw)
      .then(function (response) {
        return response
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/statelaws.js